define('shared/remote/country/state/city/Entity',[
    'shared/lib/RSVP'
], 
function (
    RSVP
) {
    'use strict';

    function Ctor(marketCode, stateCode, cqJson) {
        this._marketCode = marketCode;
        this._stateCode = stateCode;
        this._data = cqJson;
        this._code = cqJson.code;
        this._name = cqJson.name;
        this._phones = {};

        if ( cqJson.mobile ) {
            this._phones.mobile = {
                prefix: typeof cqJson.mobile === 'string' ? [cqJson.mobile] : cqJson.mobile
            };
        }
        
        if ( cqJson.landline ) {
            this._phones.landline = {
                prefix: typeof cqJson.landline === 'string' ? [cqJson.landline] : cqJson.landline
            };
        }
    }

    var p = Ctor.prototype;

    p.marketCode = function () {
        return this._marketCode;
    };

    p.stateCode = function () {
        return this._stateCode;
    };

    p.code = function () {
        return this._code;
    };

    p.name = function () {
        return this._name;
    };

    p.phones = function () {
        return this._phones;
    };

    return Ctor;
});
